import { Radio } from '@ksyos/design-system';
import type { OsasEvaluationData } from '@common/validation/customControls/osas/osasEvaluationSchemas/types';
import { OsasPressureUnit } from '@common/enums';
import { useProcessActivityEditContext } from '@frontend/utils';
import { RadioGroupFormGroup, TextInputField } from '../../../processActivityFormGroupFields';

export function PressureFormGroup(
    props: Readonly<{
        fieldKey: keyof Pick<
            OsasEvaluationData,
            | 'pressureApapMaximum'
            | 'pressureApapMinimum'
            | 'pressureApapNinetyfive'
            | 'pressureIpap'
            | 'pressureEpap'
            | 'pressureCpap'
        >;
        label: string;
    }>
) {
    const { data, onChange } = useProcessActivityEditContext<OsasEvaluationData>();

    return (
        <RadioGroupFormGroup
            fieldKey={props.fieldKey}
            label={props.label}
            onChange={async (value) => {
                onChange({ [props.fieldKey]: { unit: value, value: null } }, props.fieldKey);
            }}
            radioGroupLayout="column"
            value={data[props.fieldKey].unit ?? undefined}
        >
            <Radio
                key={OsasPressureUnit.cmH2O}
                label={OsasPressureUnit.cmH2O}
                value={OsasPressureUnit.cmH2O}
            />
            <>
                {data[props.fieldKey].unit === OsasPressureUnit.cmH2O && (
                    <TextInputField fieldKey={`${[props.fieldKey]}.value`} />
                )}
            </>

            <Radio
                key={OsasPressureUnit.hPa}
                label={OsasPressureUnit.hPa}
                value={OsasPressureUnit.hPa}
            />
            <>
                {data[props.fieldKey].unit === OsasPressureUnit.hPa && (
                    <TextInputField fieldKey={`${[props.fieldKey]}.value`} />
                )}
            </>
        </RadioGroupFormGroup>
    );
}
